import { service } from './service'; // 获取送货单报表List

export function GetDeliveryNoteReport(query) {
  return service({
    url: 'DeliveryNoteReport/GetDeliveryNoteReport',
    params: query,
    method: 'get'
  });
} // 导出报表list

export function ExportListData(data) {
  return service({
    url: 'DeliveryNoteReport/ExportListData',
    method: 'post',
    data: data
  });
}